<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>分享与推送</el-breadcrumb-item>
          <el-breadcrumb-item>我的分享</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>我的分享</h4>
        <!-- <p>+新增用户</p> -->
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <mysharetable :tableData="tableData"
                        @seePic="seePic"></mysharetable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mysharetable } from "@/components/index";
import { listPicturePackage, getPicturePackage } from "@/api/picturePackage";
import { getDate, formatConversion } from "@/plugins/getdate";
import { getPushChannel } from "@/api/pushChannel";
export default {
  components: {
    mysharetable: mysharetable
  },

  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      timeInt: "",
      isRefresh: false
    };
  },
  methods: {
    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      let data = {
        page: this.currentPage - 1,
        pageSize: this.pageSize,
        packageType: "share",
        targetUid:0
      };
      // console.log(data)
      this.listPicturePackageAsync(data);
    },

    seePic (data) {
      // console.log(data.row)
      this.$router.push({
        path: '/shareAndPush/show',
        query: {
          data: JSON.stringify(data.row)
        }
      })
    },

    //刷新表格
    refresh () {
      this.isRefresh = true;
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },

    //获取下载列表

    async listPicturePackageAsync (val) {
      this.isRefresh = true;
      let { status, data, message, pagination, errors } = await listPicturePackage(val);
      if (status) {
        this.total = pagination.total;

        for (let i = 0; i < data.length; i++) {
          // let shareInfo = await getPicturePackage(data[i].id)
          // shareInfo.data.pushConfig = JSON.parse(shareInfo.data.pushConfig)
          // let shareChannel = await getPushChannel(shareInfo.data.pushConfig.pushChannelId)

          // data[i].channel = shareChannel.data.name

          data[i].createAtMY = formatConversion(data[i].createAt.toString());
        }

        this.tableData = data;

        this.isRefresh = false;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false;
      }
    }
  },
  created () {
    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {
    // 组件销毁前调用
    clearTimeout(this.timeInt);
  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./myshare.scss";

h4 {
  font-size: 18px;
}
</style>
